import { fromZonedTime } from 'date-fns-tz';
import { AbstractModel } from '@/models/abstractModel';
import { ITurnoverEventApi } from '@/types';
import { EventStatus } from '@/types/event';

export class TurnoverEventItem extends AbstractModel {
    public balance: number;
    public betCount: number;
    public customEventId: string;
    public customLeagueLimitsCategoryId: number | null;
    public customLeagueName: string;
    public customTeamAwayName: string;
    public customTeamHomeName: string;
    public eventDate: string;
    public score: string | null;
    public scoreFt: string | null;
    public scoreHt: string | null;
    public settledBetCount: number;
    public stakeSum: number;
    public time: string | null;
    public unsettledBetCount: number;
    public userCount: number;

    constructor(data: ITurnoverEventApi) {
        super();
        this.customEventId = data.custom_event_id;
        this.eventDate = data.date;
        this.betCount = data.bet_count;
        this.settledBetCount = data.settled_bet_count;
        this.unsettledBetCount = data.unsettled_bet_count;
        this.stakeSum = data.stake_sum;
        this.balance = data.balance;
        this.customLeagueName = data.custom_league_name;
        this.customLeagueLimitsCategoryId = data.custom_league_limits_category_id;
        this.customTeamHomeName = data.custom_team_home_name;
        this.customTeamAwayName = data.custom_team_away_name;
        this.userCount = data.user_count;
        this.time = data.time;
        this.score = data.score;
        this.scoreHt = data.score_ht;
        this.scoreFt = data.score_ft;
    }

    get eventStatus(): EventStatus {
        const isDatePassed = fromZonedTime(this.eventDate, 'Europe/London') > new Date();
        if (this.score) {
            return EventStatus.Playing;
        } else if (isDatePassed) {
            return EventStatus.NotStarted;
        } else if (this.unsettledBetCount) {
            return EventStatus.Settling;
        } else {
            return EventStatus.Settled;
        }
    }

    get eventStatusText(): string {
        switch (this.eventStatus) {
            case EventStatus.Playing:
                return this.t('turnoverEvent.playing');
            case EventStatus.NotStarted:
                return this.t('turnoverEvent.notStarted');
            case EventStatus.Settling:
                return this.t('turnoverEvent.settling');
            case EventStatus.Settled:
                return this.t('turnoverEvent.settled');
        }
    }

    public displayedEventScore(): string {
        return this.score || this.scoreFt || '';
    }
}
